(function() {
  if (!('ontouchstart' in window)) return;

  const style = document.createElement('style');
  style.textContent = `
    .nlx-ripple {
      position: fixed;
      border-radius: 50%;
      pointer-events: none;
      z-index: 99999;
      transform: translate(-50%, -50%) scale(0);
      animation: nlx-ripple-out 0.6s ease-out forwards;
    }

    .nlx-ripple-inner {
      position: fixed;
      border-radius: 50%;
      pointer-events: none;
      z-index: 99999;
      transform: translate(-50%, -50%) scale(0);
      animation: nlx-ripple-out 0.35s ease-out forwards;
    }

    @keyframes nlx-ripple-out {
      0% {
        transform: translate(-50%, -50%) scale(0);
        opacity: 1;
      }
      100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

  const canvas = document.createElement('canvas');
  canvas.style.cssText = `
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 99998;
    mix-blend-mode: screen;
  `;
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  const particles = [];
  let lastX = 0;
  let lastY = 0;

  function spawnParticles(x, y) {
    for (let i = 0; i < 4; i++) {
      particles.push({
        x,
        y,
        vx: (Math.random() - 0.5) * 2,
        vy: (Math.random() - 0.5) * 2,
        life: 1,
        decay: 0.02 + Math.random() * 0.02,
        size: 1.5 + Math.random() * 3,
        color: Math.random() < 0.6 ? [168, 85, 247] : [96, 165, 250]
      });
    }
  }

  function spawnRipple(x, y) {
    const ripple = document.createElement('div');
    ripple.className = 'nlx-ripple';
    ripple.style.cssText = `
      left: ${x}px;
      top: ${y}px;
      width: 80px;
      height: 80px;
      border: 1.5px solid rgba(168, 85, 247, 0.7);
      box-shadow: 0 0 12px rgba(168, 85, 247, 0.4), inset 0 0 12px rgba(168, 85, 247, 0.1);
    `;

    const ripple2 = document.createElement('div');
    ripple2.className = 'nlx-ripple';
    ripple2.style.cssText = `
      left: ${x}px;
      top: ${y}px;
      width: 140px;
      height: 140px;
      border: 1px solid rgba(96, 165, 250, 0.4);
      box-shadow: 0 0 8px rgba(96, 165, 250, 0.2);
      animation-delay: 0.08s;
    `;

    const dot = document.createElement('div');
    dot.className = 'nlx-ripple-inner';
    dot.style.cssText = `
      left: ${x}px;
      top: ${y}px;
      width: 16px;
      height: 16px;
      background: rgba(168, 85, 247, 0.6);
      box-shadow: 0 0 10px rgba(168, 85, 247, 0.8), 0 0 20px rgba(168, 85, 247, 0.4);
    `;

    document.body.appendChild(dot);
    document.body.appendChild(ripple);
    document.body.appendChild(ripple2);

    setTimeout(() => {
      dot.remove();
      ripple.remove();
      ripple2.remove();
    }, 800);
  }

  document.addEventListener('touchstart', (e) => {
    const touch = e.touches[0];
    lastX = touch.clientX;
    lastY = touch.clientY;
    spawnRipple(touch.clientX, touch.clientY);
    spawnParticles(touch.clientX, touch.clientY);
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    const touch = e.touches[0];
    const x = touch.clientX;
    const y = touch.clientY;

    const dx = x - lastX;
    const dy = y - lastY;
    const dist = Math.sqrt(dx * dx + dy * dy);
    const steps = Math.max(1, Math.floor(dist / 5));

    for (let s = 0; s < steps; s++) {
      const t = s / steps;
      spawnParticles(lastX + dx * t, lastY + dy * t);
    }

    lastX = x;
    lastY = y;
  }, { passive: true });

  document.addEventListener('touchend', () => {
    lastX = 0;
    lastY = 0;
  }, { passive: true });

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.x += p.vx;
      p.y += p.vy;
      p.vx *= 0.98;
      p.vy *= 0.98;
      p.life -= p.decay;

      if (p.life <= 0) {
        particles.splice(i, 1);
        continue;
      }

      const [r, g, b] = p.color;

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size * p.life, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${r},${g},${b},${p.life * 0.8})`;
      ctx.fill();

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size * p.life * 3, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${r},${g},${b},${p.life * 0.1})`;
      ctx.fill();
    }

    requestAnimationFrame(animate);
  }

  animate();
})();
